// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkListStyles } from "@eisinc/Overrides/Widgets/Basic/LinkList";
import { resolveColor } from "@insite/mobius/utilities";
import { css } from "styled-components";

// EIS-4193 - Update title to h2 to fix "heading elements are not in a sequentially-descending order"
linkListStyles.title = {
    forwardAs: "h2",
};

linkListStyles.linkListWrapper = {
    css: css`
            padding: 10px 0;
        `,
};
linkListStyles.titleWrapper = {
    css: css`
            font-weight: bold;
            margin-bottom: 10px;
            font-size: 18px;
            color: ${props => resolveColor("primary.main", props.theme)};
        `,
};
linkListStyles.linkWrapper = {
    css: css`
            padding: 1px 18px 0 0;
        `,
};